<template>
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse">
    <div class="h-6 bg-gray-200 rounded mb-2"></div>
    <div class="h-4 bg-gray-200 rounded mb-4 w-3/4"></div>
    <div class="flex justify-between items-center">
      <div class="h-4 bg-gray-200 rounded w-1/4"></div>
      <div class="h-4 bg-gray-200 rounded w-1/4"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
// 스켈레톤 컴포넌트
</script>